module.exports = __webpack_public_path__ + "img/development.b7cbbb00.png";